import { render, staticRenderFns } from "./ReportAuditByWorkplace.vue?vue&type=template&id=a1537564"
import script from "./ReportAuditByWorkplace.vue?vue&type=script&lang=ts"
export * from "./ReportAuditByWorkplace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports